import { signOut } from '../lib/auth';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';

export default function NotAuthorized({
  email,
  loading,
}: {
  email: string;
  loading?: boolean;
}) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <Spinner label="Verificando consultório…" />
      </div>
    );
  }

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: 'var(--bb-bg)' }}
    >
      <div className="card shadow-sm" style={{ maxWidth: 520, width: '100%' }}>
        <div className="card-body p-4">
          <div className="text-center mb-3">
            <i
              className="bi bi-shield-lock"
              style={{ fontSize: '2.5rem', color: '#dc3545' }}
            />
            <h1 className="h4 mt-2">Sem acesso ao consultório</h1>
          </div>
          <p className="text-muted small">
            O email <strong>{email}</strong> está autenticado, mas não está
            vinculado a nenhum consultório no BebêCare.
          </p>
          <p className="text-muted small">
            Peça ao time BebêCare para rodar no SQL Editor do Supabase:
          </p>
          <pre
            className="bg-light p-3 rounded small"
            style={{ fontSize: '0.75rem' }}
          >{`INSERT INTO public.practice_members (practice_id, user_id, role)
SELECT p.id, u.id, 'ADMIN'
FROM public.practices p
JOIN auth.users u ON u.email = '${email}'
WHERE p.slug = 'dra-fernanda' AND p.product = 'bebecare';`}</pre>
          <div className="d-flex gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={async () => {
                await signOut();
                navigate('/login', { replace: true });
              }}
            >
              Sair
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
